'use client';

import { blackTransparentLoaderModalAtom, confirmModalAtom } from '@/atom/modal';
import { signinWithZzimToken } from '@/utils/actions';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import WritePencil1820 from '@svg/sharing-trips/write_pencil_18_20.svg';

export default function SharingTripsWriteFloatingButton() {
  const router = useRouter();
  const setBlackTransparentLoaderModal = useSetAtom(blackTransparentLoaderModalAtom);
  const setConfirmModal = useSetAtom(confirmModalAtom);

  const onClickWrite = useCallback(async () => {
    try {
      setBlackTransparentLoaderModal(true);
      const signinResult = await signinWithZzimToken();
      if (!signinResult) {
        setConfirmModal({
          visible: true,
          title: '로그인 필요',
          message: '로그인으로 이동합니다.',
          onClose: () => {
            setConfirmModal({ visible: false });
          },
          onConfirm: () => {
            setConfirmModal({ visible: false });
            window.location.href =
              process.env.NEXT_PUBLIC_ZZIMCAR_URL + 'user/signin?redirectUrl=' + window.location.href;
          },
        });
        return;
      } else {
        router.push('/board/sharing-trip-write/new');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBlackTransparentLoaderModal(false);
    }
  }, []);

  return (
    <button
      className='fixed bottom-40pxr z-[2] w-56pxr h-56pxr bg-new-point-500 rounded-full shadow-clear flex items-center justify-center'
      style={{
        right: 'max(20px, (calc(100vw - 480px) / 2) + 20px)',
      }}
      onClick={() => {
        onClickWrite();
      }}
    >
      <WritePencil1820 />
    </button>
  );
}
